import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider, QueryClient } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';

import { themeOptions } from 'components/Foundation/Theme';

import './index.css';
import '@fontsource/bitter/500';
import '@fontsource/montserrat/400';
import '@fontsource/montserrat/500';
import '@fontsource/montserrat/600';
import '@fontsource/montserrat/700';
import App from './App';
import reportWebVitals from './reportWebVitals';

const queryClient = new QueryClient();
const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <Router>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={createTheme(themeOptions)}>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </Router>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
